var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "stein",
  "block.minecraft.granite": "granit",
  "block.minecraft.polished_granite": "polierter granit",
  "block.minecraft.diorite": "diorit",
  "block.minecraft.polished_diorite": "polierter diorit",
  "block.minecraft.andesite": "andesit",
  "block.minecraft.polished_andesite": "polierter andesit",
  "block.minecraft.grass_block": "grasblock",
  "block.minecraft.dirt": "erde",
  "block.minecraft.coarse_dirt": "grobe erde",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmesin-nezel",
  "block.minecraft.warped_nylium": "wirr-nezel",
  "block.minecraft.cobblestone": "bruchstein",
  "block.minecraft.oak_planks": "eichenholzbretter",
  "block.minecraft.spruce_planks": "fichtenholzbretter",
  "block.minecraft.birch_planks": "birkenholzbretter",
  "block.minecraft.jungle_planks": "tropenholzbretter",
  "block.minecraft.acacia_planks": "akazienholzbretter",
  "block.minecraft.dark_oak_planks": "schwarzeichenholzbretter",
  "block.minecraft.crimson_planks": "karmesinbretter",
  "block.minecraft.warped_planks": "wirrbretter",
  "block.minecraft.oak_sapling": "eichensetzling",
  "block.minecraft.spruce_sapling": "fichtensetzling",
  "block.minecraft.birch_sapling": "birkensetzling",
  "block.minecraft.jungle_sapling": "tropenbaumsetzling",
  "block.minecraft.acacia_sapling": "akaziensetzling",
  "block.minecraft.dark_oak_sapling": "schwarzeichensetzling",
  "block.minecraft.bedrock": "grundgestein",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "roter sand",
  "block.minecraft.gravel": "kies",
  "block.minecraft.gold_ore": "golderz",
  "block.minecraft.iron_ore": "eisenerz",
  "block.minecraft.coal_ore": "steinkohle",
  "block.minecraft.nether_gold_ore": "nethergolderz",
  "block.minecraft.oak_log": "eichenstamm",
  "block.minecraft.spruce_log": "fichtenstamm",
  "block.minecraft.birch_log": "birkenstamm",
  "block.minecraft.jungle_log": "tropenbaumstamm",
  "block.minecraft.acacia_log": "akazienstamm",
  "block.minecraft.dark_oak_log": "schwarzeichenstamm",
  "block.minecraft.crimson_stem": "karmesinstiel",
  "block.minecraft.warped_stem": "wirrstiel",
  "block.minecraft.stripped_oak_log": "entrindeter eichenstamm",
  "block.minecraft.stripped_spruce_log": "entrindeter fichtenstamm",
  "block.minecraft.stripped_birch_log": "entrindeter birkenstamm",
  "block.minecraft.stripped_jungle_log": "entrindeter tropenbaumstamm",
  "block.minecraft.stripped_acacia_log": "entrindeter akazienstamm",
  "block.minecraft.stripped_dark_oak_log": "entrindeter schwarzeichenstamm",
  "block.minecraft.stripped_crimson_stem": "geschälter karmesinstiel",
  "block.minecraft.stripped_warped_stem": "geschälter wirrstiel",
  "block.minecraft.stripped_oak_wood": "entrindetes eichenholz",
  "block.minecraft.stripped_spruce_wood": "entrindetes fichtenholz",
  "block.minecraft.stripped_birch_wood": "entrindetes birkenholz",
  "block.minecraft.stripped_jungle_wood": "entrindetes tropenholz",
  "block.minecraft.stripped_acacia_wood": "entrindetes akazienholz",
  "block.minecraft.stripped_dark_oak_wood": "entrindetes schwarzeichenholz",
  "block.minecraft.stripped_crimson_hyphae": "geschälte karmesinhyphen",
  "block.minecraft.stripped_warped_hyphae": "geschälte wirrhyphen",
  "block.minecraft.oak_wood": "eichenholz",
  "block.minecraft.spruce_wood": "fichtenholz",
  "block.minecraft.birch_wood": "birkenholz",
  "block.minecraft.jungle_wood": "tropenholz",
  "block.minecraft.acacia_wood": "akazienholz",
  "block.minecraft.dark_oak_wood": "schwarzeichenholz",
  "block.minecraft.crimson_hyphae": "karmesinhyphen",
  "block.minecraft.warped_hyphae": "wirrhyphen",
  "block.minecraft.oak_leaves": "eichenlaub",
  "block.minecraft.spruce_leaves": "fichtennadeln",
  "block.minecraft.birch_leaves": "birkenlaub",
  "block.minecraft.jungle_leaves": "tropenbaumlaub",
  "block.minecraft.acacia_leaves": "akazienlaub",
  "block.minecraft.dark_oak_leaves": "schwarzeichenlaub",
  "block.minecraft.sponge": "schwamm",
  "block.minecraft.wet_sponge": "nasser schwamm",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lapislazulierz",
  "block.minecraft.lapis_block": "lapislazuliblock",
  "block.minecraft.dispenser": "werfer",
  "block.minecraft.sandstone": "sandstein",
  "block.minecraft.chiseled_sandstone": "gemeißelter sandstein",
  "block.minecraft.cut_sandstone": "geschnittener sandstein",
  "block.minecraft.note_block": "notenblock",
  "block.minecraft.powered_rail": "antriebsschiene",
  "block.minecraft.detector_rail": "sensorschiene",
  "block.minecraft.sticky_piston": "klebriger kolben",
  "block.minecraft.cobweb": "spinnennetz",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "farn",
  "block.minecraft.dead_bush": "toter busch",
  "block.minecraft.seagrass": "seegras",
  "block.minecraft.sea_pickle": "meeresgurke",
  "block.minecraft.piston": "kolben",
  "block.minecraft.white_wool": "weiße wolle",
  "block.minecraft.orange_wool": "orange wolle",
  "block.minecraft.magenta_wool": "magenta wolle",
  "block.minecraft.light_blue_wool": "hellblaue wolle",
  "block.minecraft.yellow_wool": "gelbe wolle",
  "block.minecraft.lime_wool": "hellgrüne wolle",
  "block.minecraft.pink_wool": "rosa wolle",
  "block.minecraft.gray_wool": "graue wolle",
  "block.minecraft.light_gray_wool": "hellgraue wolle",
  "block.minecraft.cyan_wool": "türkise wolle",
  "block.minecraft.purple_wool": "violette wolle",
  "block.minecraft.blue_wool": "blaue wolle",
  "block.minecraft.brown_wool": "braune wolle",
  "block.minecraft.green_wool": "grüne wolle",
  "block.minecraft.red_wool": "rote wolle",
  "block.minecraft.black_wool": "schwarze wolle",
  "block.minecraft.dandelion": "löwenzahn",
  "block.minecraft.poppy": "mohn",
  "block.minecraft.blue_orchid": "blaue orchidee",
  "block.minecraft.allium": "zierlauch",
  "block.minecraft.azure_bluet": "porzellansternchen",
  "block.minecraft.red_tulip": "rote tulpe",
  "block.minecraft.orange_tulip": "orange tulpe",
  "block.minecraft.white_tulip": "weiße tulpe",
  "block.minecraft.pink_tulip": "rosa tulpe",
  "block.minecraft.oxeye_daisy": "margerite",
  "block.minecraft.cornflower": "kornblume",
  "block.minecraft.lily_of_the_valley": "maiglöckchen",
  "block.minecraft.wither_rose": "wither-rose",
  "block.minecraft.brown_mushroom": "brauner pilz",
  "block.minecraft.red_mushroom": "roter pilz",
  "block.minecraft.crimson_fungus": "karmesinpilz",
  "block.minecraft.warped_fungus": "wirrpilz",
  "block.minecraft.crimson_roots": "karmesinwurzeln",
  "block.minecraft.warped_roots": "wirrwurzeln",
  "block.minecraft.nether_sprouts": "nethersprossen",
  "block.minecraft.weeping_vines": "trauerranken",
  "block.minecraft.twisting_vines": "zwirbelranken",
  "block.minecraft.sugar_cane": "zuckerrohr",
  "block.minecraft.kelp": "seetang",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "goldblock",
  "block.minecraft.iron_block": "eisenblock",
  "block.minecraft.oak_slab": "eichenholzstufe",
  "block.minecraft.spruce_slab": "fichtenholzstufe",
  "block.minecraft.birch_slab": "birkenholzstufe",
  "block.minecraft.jungle_slab": "tropenholzstufe",
  "block.minecraft.acacia_slab": "akazienholzstufe",
  "block.minecraft.dark_oak_slab": "schwarzeichenholzstufe",
  "block.minecraft.crimson_slab": "karmesinstufe",
  "block.minecraft.warped_slab": "wirrstufe",
  "block.minecraft.stone_slab": "steinstufe",
  "block.minecraft.smooth_stone_slab": "glatte steinstufe",
  "block.minecraft.sandstone_slab": "sandsteinstufe",
  "block.minecraft.cut_sandstone_slab": "geschnittene sandsteinstufe",
  "block.minecraft.petrified_oak_slab": "versteinerte eichenholzstufe",
  "block.minecraft.cobblestone_slab": "bruchsteinstufe",
  "block.minecraft.brick_slab": "ziegelstufe",
  "block.minecraft.stone_brick_slab": "steinziegelstufe",
  "block.minecraft.nether_brick_slab": "netherziegelstufe",
  "block.minecraft.quartz_slab": "quarzstufe",
  "block.minecraft.red_sandstone_slab": "rote sandsteinstufe",
  "block.minecraft.cut_red_sandstone_slab": "geschnittene rote sandsteinstufe",
  "block.minecraft.purpur_slab": "purpurstufe",
  "block.minecraft.prismarine_slab": "prismarinstufe",
  "block.minecraft.prismarine_brick_slab": "prismarinziegelstufe",
  "block.minecraft.dark_prismarine_slab": "dunkle prismarinstufe",
  "block.minecraft.smooth_quartz": "glatter quarzblock",
  "block.minecraft.smooth_red_sandstone": "glatter roter sandstein",
  "block.minecraft.smooth_sandstone": "glatter sandstein",
  "block.minecraft.smooth_stone": "glatter stein",
  "block.minecraft.bricks": "ziegelsteine",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bücherregal",
  "block.minecraft.mossy_cobblestone": "bemooster bruchstein",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fackel",
  "block.minecraft.end_rod": "endstab",
  "block.minecraft.chorus_plant": "choruspflanze",
  "block.minecraft.chorus_flower": "chorusblüte",
  "block.minecraft.purpur_block": "purpurblock",
  "block.minecraft.purpur_pillar": "purpursäule",
  "block.minecraft.purpur_stairs": "purpurtreppe",
  "block.minecraft.spawner": "spawner",
  "block.minecraft.oak_stairs": "eichenholztreppe",
  "block.minecraft.chest": "truhe",
  "block.minecraft.diamond_ore": "diamanterz",
  "block.minecraft.diamond_block": "diamantblock",
  "block.minecraft.crafting_table": "werkbank",
  "block.minecraft.farmland": "ackerboden",
  "block.minecraft.furnace": "ofen",
  "block.minecraft.ladder": "leiter",
  "block.minecraft.rail": "schiene",
  "block.minecraft.cobblestone_stairs": "bruchsteintreppe",
  "block.minecraft.lever": "hebel",
  "block.minecraft.stone_pressure_plate": "steindruckplatte",
  "block.minecraft.oak_pressure_plate": "eichenholzdruckplatte",
  "block.minecraft.spruce_pressure_plate": "fichtenholzdruckplatte",
  "block.minecraft.birch_pressure_plate": "birkenholzdruckplatte",
  "block.minecraft.jungle_pressure_plate": "tropenholzdruckplatte",
  "block.minecraft.acacia_pressure_plate": "akazienholzdruckplatte",
  "block.minecraft.dark_oak_pressure_plate": "schwarzeichenholzdruckplatte",
  "block.minecraft.crimson_pressure_plate": "karmesindruckplatte",
  "block.minecraft.warped_pressure_plate": "wirrdruckplatte",
  "block.minecraft.polished_blackstone_pressure_plate": "polierte schwarzsteindruckplatte",
  "block.minecraft.redstone_ore": "redstone-erz",
  "block.minecraft.redstone_torch": "redstone-fackel",
  "block.minecraft.snow": "schnee",
  "block.minecraft.ice": "eis",
  "block.minecraft.snow_block": "schneeblock",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "ton",
  "block.minecraft.jukebox": "plattenspieler",
  "block.minecraft.oak_fence": "eichenholzzaun",
  "block.minecraft.spruce_fence": "fichtenholzzaun",
  "block.minecraft.birch_fence": "birkenholzzaun",
  "block.minecraft.jungle_fence": "tropenholzzaun",
  "block.minecraft.acacia_fence": "akazienholzzaun",
  "block.minecraft.dark_oak_fence": "schwarzeichenholzzaun",
  "block.minecraft.crimson_fence": "karmesinzaun",
  "block.minecraft.warped_fence": "wirrzaun",
  "block.minecraft.pumpkin": "kürbis",
  "block.minecraft.carved_pumpkin": "geschnitzter kürbis",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "seelensand",
  "block.minecraft.soul_soil": "seelenerde",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "polierter basalt",
  "block.minecraft.soul_torch": "seelenfackel",
  "block.minecraft.glowstone": "glowstone",
  "block.minecraft.jack_o_lantern": "kürbislaterne",
  "block.minecraft.oak_trapdoor": "eichenholzfalltür",
  "block.minecraft.spruce_trapdoor": "fichtenholzfalltür",
  "block.minecraft.birch_trapdoor": "birkenholzfalltür",
  "block.minecraft.jungle_trapdoor": "tropenholzfalltür",
  "block.minecraft.acacia_trapdoor": "akazienholzfalltür",
  "block.minecraft.dark_oak_trapdoor": "schwarzeichenholzfalltür",
  "block.minecraft.crimson_trapdoor": "karmesinfalltür",
  "block.minecraft.warped_trapdoor": "wirrfalltür",
  "block.minecraft.infested_stone": "befallener stein",
  "block.minecraft.infested_cobblestone": "befallener bruchstein",
  "block.minecraft.infested_stone_bricks": "befallene steinziegel",
  "block.minecraft.infested_mossy_stone_bricks": "befallene bemooste steinziegel",
  "block.minecraft.infested_cracked_stone_bricks": "befallene rissige steinziegel",
  "block.minecraft.infested_chiseled_stone_bricks": "befallene gemeißelte steinziegel",
  "block.minecraft.stone_bricks": "steinziegel",
  "block.minecraft.mossy_stone_bricks": "bemooste steinziegel",
  "block.minecraft.cracked_stone_bricks": "rissige steinziegel",
  "block.minecraft.chiseled_stone_bricks": "gemeißelte steinziegel",
  "block.minecraft.brown_mushroom_block": "brauner pilzblock",
  "block.minecraft.red_mushroom_block": "roter pilzblock",
  "block.minecraft.mushroom_stem": "pilzstiel",
  "block.minecraft.iron_bars": "eisengitter",
  "block.minecraft.chain": "kette",
  "block.minecraft.glass_pane": "glasscheibe",
  "block.minecraft.melon": "melone",
  "block.minecraft.vine": "ranken",
  "block.minecraft.oak_fence_gate": "eichenholzzauntor",
  "block.minecraft.spruce_fence_gate": "fichtenholzzauntor",
  "block.minecraft.birch_fence_gate": "birkenholzzauntor",
  "block.minecraft.jungle_fence_gate": "tropenholzzauntor",
  "block.minecraft.acacia_fence_gate": "akazienholzzauntor",
  "block.minecraft.dark_oak_fence_gate": "schwarzeichenholzzauntor",
  "block.minecraft.crimson_fence_gate": "karmesinzauntor",
  "block.minecraft.warped_fence_gate": "wirrzauntor",
  "block.minecraft.brick_stairs": "ziegeltreppe",
  "block.minecraft.stone_brick_stairs": "steinziegeltreppe",
  "block.minecraft.mycelium": "myzel",
  "block.minecraft.lily_pad": "seerosenblatt",
  "block.minecraft.nether_bricks": "netherziegel",
  "block.minecraft.cracked_nether_bricks": "rissige netherziegel",
  "block.minecraft.chiseled_nether_bricks": "gemeißelte netherziegel",
  "block.minecraft.nether_brick_fence": "netherziegelzaun",
  "block.minecraft.nether_brick_stairs": "netherziegeltreppe",
  "block.minecraft.enchanting_table": "zaubertisch",
  "block.minecraft.end_portal_frame": "endportalrahmen",
  "block.minecraft.end_stone": "endstein",
  "block.minecraft.end_stone_bricks": "endsteinziegel",
  "block.minecraft.dragon_egg": "drachenei",
  "block.minecraft.redstone_lamp": "redstone-lampe",
  "block.minecraft.sandstone_stairs": "sandsteintreppe",
  "block.minecraft.emerald_ore": "smaragderz",
  "block.minecraft.ender_chest": "endertruhe",
  "block.minecraft.tripwire_hook": "haken",
  "block.minecraft.emerald_block": "smaragdblock",
  "block.minecraft.spruce_stairs": "fichtenholztreppe",
  "block.minecraft.birch_stairs": "birkenholztreppe",
  "block.minecraft.jungle_stairs": "tropenholztreppe",
  "block.minecraft.crimson_stairs": "karmesintreppe",
  "block.minecraft.warped_stairs": "wirrtreppe",
  "block.minecraft.command_block": "befehlsblock",
  "block.minecraft.beacon": "leuchtfeuer",
  "block.minecraft.cobblestone_wall": "bruchsteinmauer",
  "block.minecraft.mossy_cobblestone_wall": "bemooste bruchsteinmauer",
  "block.minecraft.brick_wall": "ziegelsteinmauer",
  "block.minecraft.prismarine_wall": "prismarinmauer",
  "block.minecraft.red_sandstone_wall": "rote sandsteinmauer",
  "block.minecraft.mossy_stone_brick_wall": "bemooste steinziegelmauer",
  "block.minecraft.granite_wall": "granitmauer",
  "block.minecraft.stone_brick_wall": "steinziegelmauer",
  "block.minecraft.nether_brick_wall": "netherziegelmauer",
  "block.minecraft.andesite_wall": "andesitmauer",
  "block.minecraft.red_nether_brick_wall": "rote netherziegelmauer",
  "block.minecraft.sandstone_wall": "sandsteinmauer",
  "block.minecraft.end_stone_brick_wall": "endsteinziegelmauer",
  "block.minecraft.diorite_wall": "dioritmauer",
  "block.minecraft.blackstone_wall": "schwarzsteinmauer",
  "block.minecraft.polished_blackstone_wall": "polierte schwarzsteinmauer",
  "block.minecraft.polished_blackstone_brick_wall": "polierte schwarzsteinziegelmauer",
  "block.minecraft.stone_button": "steinknopf",
  "block.minecraft.oak_button": "eichenholzknopf",
  "block.minecraft.spruce_button": "fichtenholzknopf",
  "block.minecraft.birch_button": "birkenholzknopf",
  "block.minecraft.jungle_button": "tropenholzknopf",
  "block.minecraft.acacia_button": "akazienholzknopf",
  "block.minecraft.dark_oak_button": "schwarzeichenholzknopf",
  "block.minecraft.crimson_button": "karmesinknopf",
  "block.minecraft.warped_button": "wirrknopf",
  "block.minecraft.polished_blackstone_button": "polierter schwarzsteinknopf",
  "block.minecraft.anvil": "amboss",
  "block.minecraft.chipped_anvil": "angeschlagener amboss",
  "block.minecraft.damaged_anvil": "beschädigter amboss",
  "block.minecraft.trapped_chest": "redstone-truhe",
  "block.minecraft.light_weighted_pressure_plate": "feinwägeplatte",
  "block.minecraft.heavy_weighted_pressure_plate": "grobwägeplatte",
  "block.minecraft.daylight_detector": "tageslichtsensor",
  "block.minecraft.redstone_block": "redstone-block",
  "block.minecraft.nether_quartz_ore": "netherquarzerz",
  "block.minecraft.hopper": "trichter",
  "block.minecraft.chiseled_quartz_block": "gemeißelter quarzblock",
  "block.minecraft.quartz_block": "quarzblock",
  "block.minecraft.quartz_bricks": "quarzziegel",
  "block.minecraft.quartz_pillar": "quarzsäule",
  "block.minecraft.quartz_stairs": "quarztreppe",
  "block.minecraft.activator_rail": "aktivierungsschiene",
  "block.minecraft.dropper": "spender",
  "block.minecraft.white_terracotta": "weiße keramik",
  "block.minecraft.orange_terracotta": "orange keramik",
  "block.minecraft.magenta_terracotta": "magenta keramik",
  "block.minecraft.light_blue_terracotta": "hellblaue keramik",
  "block.minecraft.yellow_terracotta": "gelbe keramik",
  "block.minecraft.lime_terracotta": "hellgrüne keramik",
  "block.minecraft.pink_terracotta": "rosa keramik",
  "block.minecraft.gray_terracotta": "graue keramik",
  "block.minecraft.light_gray_terracotta": "hellgraue keramik",
  "block.minecraft.cyan_terracotta": "türkise keramik",
  "block.minecraft.purple_terracotta": "violette keramik",
  "block.minecraft.blue_terracotta": "blaue keramik",
  "block.minecraft.brown_terracotta": "braune keramik",
  "block.minecraft.green_terracotta": "grüne keramik",
  "block.minecraft.red_terracotta": "rote keramik",
  "block.minecraft.black_terracotta": "schwarze keramik",
  "block.minecraft.barrier": "barriere",
  "block.minecraft.iron_trapdoor": "eisenfalltür",
  "block.minecraft.hay_block": "strohballen",
  "block.minecraft.white_carpet": "weißer teppich",
  "block.minecraft.orange_carpet": "oranger teppich",
  "block.minecraft.magenta_carpet": "magenta teppich",
  "block.minecraft.light_blue_carpet": "hellblauer teppich",
  "block.minecraft.yellow_carpet": "gelber teppich",
  "block.minecraft.lime_carpet": "hellgrüner teppich",
  "block.minecraft.pink_carpet": "rosa teppich",
  "block.minecraft.gray_carpet": "grauer teppich",
  "block.minecraft.light_gray_carpet": "hellgrauer teppich",
  "block.minecraft.cyan_carpet": "türkiser teppich",
  "block.minecraft.purple_carpet": "violetter teppich",
  "block.minecraft.blue_carpet": "blauer teppich",
  "block.minecraft.brown_carpet": "brauner teppich",
  "block.minecraft.green_carpet": "grüner teppich",
  "block.minecraft.red_carpet": "roter teppich",
  "block.minecraft.black_carpet": "schwarzer teppich",
  "block.minecraft.terracotta": "keramik",
  "block.minecraft.coal_block": "kohleblock",
  "block.minecraft.packed_ice": "packeis",
  "block.minecraft.acacia_stairs": "akazienholztreppe",
  "block.minecraft.dark_oak_stairs": "schwarzeichenholztreppe",
  "block.minecraft.slime_block": "schleimblock",
  "block.minecraft.grass_path": "trampelpfad",
  "block.minecraft.sunflower": "sonnenblume",
  "block.minecraft.lilac": "flieder",
  "block.minecraft.rose_bush": "rosenstrauch",
  "block.minecraft.peony": "pfingstrose",
  "block.minecraft.tall_grass": "hohes gras",
  "block.minecraft.large_fern": "großer farn",
  "block.minecraft.white_stained_glass": "weißes glas",
  "block.minecraft.orange_stained_glass": "oranges glas",
  "block.minecraft.magenta_stained_glass": "magenta glas",
  "block.minecraft.light_blue_stained_glass": "hellblaues glas",
  "block.minecraft.yellow_stained_glass": "gelbes glas",
  "block.minecraft.lime_stained_glass": "hellgrünes glas",
  "block.minecraft.pink_stained_glass": "rosa glas",
  "block.minecraft.gray_stained_glass": "graues glas",
  "block.minecraft.light_gray_stained_glass": "hellgraues glas",
  "block.minecraft.cyan_stained_glass": "türkises glas",
  "block.minecraft.purple_stained_glass": "violettes glas",
  "block.minecraft.blue_stained_glass": "blaues glas",
  "block.minecraft.brown_stained_glass": "braunes glas",
  "block.minecraft.green_stained_glass": "grünes glas",
  "block.minecraft.red_stained_glass": "rotes glas",
  "block.minecraft.black_stained_glass": "schwarzes glas",
  "block.minecraft.white_stained_glass_pane": "weiße glasscheibe",
  "block.minecraft.orange_stained_glass_pane": "orange glasscheibe",
  "block.minecraft.magenta_stained_glass_pane": "magenta glasscheibe",
  "block.minecraft.light_blue_stained_glass_pane": "hellblaue glasscheibe",
  "block.minecraft.yellow_stained_glass_pane": "gelbe glasscheibe",
  "block.minecraft.lime_stained_glass_pane": "hellgrüne glasscheibe",
  "block.minecraft.pink_stained_glass_pane": "rosa glasscheibe",
  "block.minecraft.gray_stained_glass_pane": "graue glasscheibe",
  "block.minecraft.light_gray_stained_glass_pane": "hellgraue glasscheibe",
  "block.minecraft.cyan_stained_glass_pane": "türkise glasscheibe",
  "block.minecraft.purple_stained_glass_pane": "violette glasscheibe",
  "block.minecraft.blue_stained_glass_pane": "blaue glasscheibe",
  "block.minecraft.brown_stained_glass_pane": "braune glasscheibe",
  "block.minecraft.green_stained_glass_pane": "grüne glasscheibe",
  "block.minecraft.red_stained_glass_pane": "rote glasscheibe",
  "block.minecraft.black_stained_glass_pane": "schwarze glasscheibe",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinziegel",
  "block.minecraft.dark_prismarine": "dunkler prismarin",
  "block.minecraft.prismarine_stairs": "prismarintreppe",
  "block.minecraft.prismarine_brick_stairs": "prismarinziegeltreppe",
  "block.minecraft.dark_prismarine_stairs": "dunkle prismarintreppe",
  "block.minecraft.sea_lantern": "seelaterne",
  "block.minecraft.red_sandstone": "roter sandstein",
  "block.minecraft.chiseled_red_sandstone": "gemeißelter roter sandstein",
  "block.minecraft.cut_red_sandstone": "geschnittener roter sandstein",
  "block.minecraft.red_sandstone_stairs": "rote sandsteintreppe",
  "block.minecraft.repeating_command_block": "wiederhol-befehlsblock",
  "block.minecraft.chain_command_block": "ketten-befehlsblock",
  "block.minecraft.magma_block": "magmablock",
  "block.minecraft.nether_wart_block": "netherwarzenblock",
  "block.minecraft.warped_wart_block": "wirrwarzenblock",
  "block.minecraft.red_nether_bricks": "rote netherziegel",
  "block.minecraft.bone_block": "knochenblock",
  "block.minecraft.structure_void": "konstruktionsleere",
  "block.minecraft.observer": "beobachter",
  "block.minecraft.shulker_box": "shulker-kiste",
  "block.minecraft.white_shulker_box": "weiße shulker-kiste",
  "block.minecraft.orange_shulker_box": "orange shulker-kiste",
  "block.minecraft.magenta_shulker_box": "magenta shulker-kiste",
  "block.minecraft.light_blue_shulker_box": "hellblaue shulker-kiste",
  "block.minecraft.yellow_shulker_box": "gelbe shulker-kiste",
  "block.minecraft.lime_shulker_box": "hellgrüne shulker-kiste",
  "block.minecraft.pink_shulker_box": "rosa shulker-kiste",
  "block.minecraft.gray_shulker_box": "graue shulker-kiste",
  "block.minecraft.light_gray_shulker_box": "hellgraue shulker-kiste",
  "block.minecraft.cyan_shulker_box": "türkise shulker-kiste",
  "block.minecraft.purple_shulker_box": "violette shulker-kiste",
  "block.minecraft.blue_shulker_box": "blaue shulker-kiste",
  "block.minecraft.brown_shulker_box": "braune shulker-kiste",
  "block.minecraft.green_shulker_box": "grüne shulker-kiste",
  "block.minecraft.red_shulker_box": "rote shulker-kiste",
  "block.minecraft.black_shulker_box": "schwarze shulker-kiste",
  "block.minecraft.white_glazed_terracotta": "weiße glasierte keramik",
  "block.minecraft.orange_glazed_terracotta": "orange glasierte keramik",
  "block.minecraft.magenta_glazed_terracotta": "magenta glasierte keramik",
  "block.minecraft.light_blue_glazed_terracotta": "hellblaue glasierte keramik",
  "block.minecraft.yellow_glazed_terracotta": "gelbe glasierte keramik",
  "block.minecraft.lime_glazed_terracotta": "hellgrüne glasierte keramik",
  "block.minecraft.pink_glazed_terracotta": "rosa glasierte keramik",
  "block.minecraft.gray_glazed_terracotta": "graue glasierte keramik",
  "block.minecraft.light_gray_glazed_terracotta": "hellgraue glasierte keramik",
  "block.minecraft.cyan_glazed_terracotta": "türkise glasierte keramik",
  "block.minecraft.purple_glazed_terracotta": "violette glasierte keramik",
  "block.minecraft.blue_glazed_terracotta": "blaue glasierte keramik",
  "block.minecraft.brown_glazed_terracotta": "braune glasierte keramik",
  "block.minecraft.green_glazed_terracotta": "grüne glasierte keramik",
  "block.minecraft.red_glazed_terracotta": "rote glasierte keramik",
  "block.minecraft.black_glazed_terracotta": "schwarze glasierte keramik",
  "block.minecraft.white_concrete": "weißer beton",
  "block.minecraft.orange_concrete": "oranger beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "hellblauer beton",
  "block.minecraft.yellow_concrete": "gelber beton",
  "block.minecraft.lime_concrete": "hellgrüner beton",
  "block.minecraft.pink_concrete": "rosa beton",
  "block.minecraft.gray_concrete": "grauer beton",
  "block.minecraft.light_gray_concrete": "hellgrauer beton",
  "block.minecraft.cyan_concrete": "türkiser beton",
  "block.minecraft.purple_concrete": "violetter beton",
  "block.minecraft.blue_concrete": "blauer beton",
  "block.minecraft.brown_concrete": "brauner beton",
  "block.minecraft.green_concrete": "grüner beton",
  "block.minecraft.red_concrete": "roter beton",
  "block.minecraft.black_concrete": "schwarzer beton",
  "block.minecraft.white_concrete_powder": "weißer trockenbeton",
  "block.minecraft.orange_concrete_powder": "oranger trockenbeton",
  "block.minecraft.magenta_concrete_powder": "magenta trockenbeton",
  "block.minecraft.light_blue_concrete_powder": "hellblauer trockenbeton",
  "block.minecraft.yellow_concrete_powder": "gelber trockenbeton",
  "block.minecraft.lime_concrete_powder": "hellgrüner trockenbeton",
  "block.minecraft.pink_concrete_powder": "rosa trockenbeton",
  "block.minecraft.gray_concrete_powder": "grauer trockenbeton",
  "block.minecraft.light_gray_concrete_powder": "hellgrauer trockenbeton",
  "block.minecraft.cyan_concrete_powder": "türkiser trockenbeton",
  "block.minecraft.purple_concrete_powder": "violetter trockenbeton",
  "block.minecraft.blue_concrete_powder": "blauer trockenbeton",
  "block.minecraft.brown_concrete_powder": "brauner trockenbeton",
  "block.minecraft.green_concrete_powder": "grüner trockenbeton",
  "block.minecraft.red_concrete_powder": "roter trockenbeton",
  "block.minecraft.black_concrete_powder": "schwarzer trockenbeton",
  "block.minecraft.turtle_egg": "schildkrötenei",
  "block.minecraft.dead_tube_coral_block": "abgestorbener orgelkorallenblock",
  "block.minecraft.dead_brain_coral_block": "abgestorbener hirnkorallenblock",
  "block.minecraft.dead_bubble_coral_block": "abgestorbener blasenkorallenblock",
  "block.minecraft.dead_fire_coral_block": "abgestorbener feuerkorallenblock",
  "block.minecraft.dead_horn_coral_block": "abgestorbener geweihkorallenblock",
  "block.minecraft.tube_coral_block": "orgelkorallenblock",
  "block.minecraft.brain_coral_block": "hirnkorallenblock",
  "block.minecraft.bubble_coral_block": "blasenkorallenblock",
  "block.minecraft.fire_coral_block": "feuerkorallenblock",
  "block.minecraft.horn_coral_block": "geweihkorallenblock",
  "block.minecraft.tube_coral": "orgelkoralle",
  "block.minecraft.brain_coral": "hirnkoralle",
  "block.minecraft.bubble_coral": "blasenkoralle",
  "block.minecraft.fire_coral": "feuerkoralle",
  "block.minecraft.horn_coral": "geweihkoralle",
  "block.minecraft.dead_brain_coral": "abgestorbene hirnkoralle",
  "block.minecraft.dead_bubble_coral": "abgestorbene blasenkoralle",
  "block.minecraft.dead_fire_coral": "abgestorbene feuerkoralle",
  "block.minecraft.dead_horn_coral": "abgestorbene geweihkoralle",
  "block.minecraft.dead_tube_coral": "abgestorbene orgelkoralle",
  "block.minecraft.tube_coral_fan": "orgelkorallenfächer",
  "block.minecraft.brain_coral_fan": "hirnkorallenfächer",
  "block.minecraft.bubble_coral_fan": "blasenkorallenfächer",
  "block.minecraft.fire_coral_fan": "feuerkorallenfächer",
  "block.minecraft.horn_coral_fan": "geweihkorallenfächer",
  "block.minecraft.dead_tube_coral_fan": "abgestorbener orgelkorallenfächer",
  "block.minecraft.dead_brain_coral_fan": "abgestorbener hirnkorallenfächer",
  "block.minecraft.dead_bubble_coral_fan": "abgestorbener blasenkorallenfächer",
  "block.minecraft.dead_fire_coral_fan": "abgestorbener feuerkorallenfächer",
  "block.minecraft.dead_horn_coral_fan": "abgestorbener geweihkorallenfächer",
  "block.minecraft.blue_ice": "blaueis",
  "block.minecraft.conduit": "aquisator",
  "block.minecraft.polished_granite_stairs": "polierte granittreppe",
  "block.minecraft.smooth_red_sandstone_stairs": "glatte rote sandsteintreppe",
  "block.minecraft.mossy_stone_brick_stairs": "bemooste steinziegeltreppe",
  "block.minecraft.polished_diorite_stairs": "polierte diorittreppe",
  "block.minecraft.mossy_cobblestone_stairs": "bemooste bruchsteintreppe",
  "block.minecraft.end_stone_brick_stairs": "endsteinziegeltreppe",
  "block.minecraft.stone_stairs": "steintreppe",
  "block.minecraft.smooth_sandstone_stairs": "glatte sandsteintreppe",
  "block.minecraft.smooth_quartz_stairs": "glatte quarztreppe",
  "block.minecraft.granite_stairs": "granittreppe",
  "block.minecraft.andesite_stairs": "andesittreppe",
  "block.minecraft.red_nether_brick_stairs": "rote netherziegeltreppe",
  "block.minecraft.polished_andesite_stairs": "polierte andesittreppe",
  "block.minecraft.diorite_stairs": "diorittreppe",
  "block.minecraft.polished_granite_slab": "polierte granitstufe",
  "block.minecraft.smooth_red_sandstone_slab": "glatte rote sandsteinstufe",
  "block.minecraft.mossy_stone_brick_slab": "bemooste steinziegelstufe",
  "block.minecraft.polished_diorite_slab": "polierte dioritstufe",
  "block.minecraft.mossy_cobblestone_slab": "bemooste bruchsteinstufe",
  "block.minecraft.end_stone_brick_slab": "endsteinziegelstufe",
  "block.minecraft.smooth_sandstone_slab": "glatte sandsteinstufe",
  "block.minecraft.smooth_quartz_slab": "glatte quarzstufe",
  "block.minecraft.granite_slab": "granitstufe",
  "block.minecraft.andesite_slab": "andesitstufe",
  "block.minecraft.red_nether_brick_slab": "rote netherziegelstufe",
  "block.minecraft.polished_andesite_slab": "polierte andesitstufe",
  "block.minecraft.diorite_slab": "dioritstufe",
  "block.minecraft.scaffolding": "gerüst",
  "block.minecraft.iron_door": "eisentür",
  "block.minecraft.oak_door": "eichenholztür",
  "block.minecraft.spruce_door": "fichtenholztür",
  "block.minecraft.birch_door": "birkenholztür",
  "block.minecraft.jungle_door": "tropenholztür",
  "block.minecraft.acacia_door": "akazienholztür",
  "block.minecraft.dark_oak_door": "schwarzeichenholztür",
  "block.minecraft.crimson_door": "karmesintür",
  "block.minecraft.warped_door": "wirrtür",
  "block.minecraft.repeater": "redstone-verstärker",
  "block.minecraft.comparator": "redstone-komparator",
  "block.minecraft.structure_block": "konstruktionsblock",
  "block.minecraft.jigsaw": "verbundblock",
  "item.minecraft.turtle_helmet": "schildkrötenpanzer□□auf dem kopf:□+2 rüstung",
  "item.minecraft.scute": "hornschild",
  "item.minecraft.iron_shovel": "eisenschaufel□□in der haupthand:□+3.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.iron_pickaxe": "eisenspitzhacke□□in der haupthand:□+3 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.iron_axe": "eisenaxt□□in der haupthand:□+8 angriffsschaden□-3.1 angriffsgeschwindigkeit",
  "item.minecraft.flint_and_steel": "feuerzeug",
  "item.minecraft.apple": "apfel",
  "item.minecraft.bow": "bogen",
  "item.minecraft.arrow": "pfeil",
  "item.minecraft.coal": "kohle",
  "item.minecraft.charcoal": "holzkohle",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "eisenbarren",
  "item.minecraft.gold_ingot": "goldbarren",
  "item.minecraft.netherite_ingot": "netheritbarren",
  "item.minecraft.netherite_scrap": "netheritplatten",
  "item.minecraft.iron_sword": "eisenschwert□□in der haupthand:□+5 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.wooden_sword": "holzschwert□□in der haupthand:□+3 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.wooden_shovel": "holzschaufel□□in der haupthand:□+1.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.wooden_pickaxe": "holzspitzhacke□□in der haupthand:□+1 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.wooden_axe": "holzaxt□□in der haupthand:□+6 angriffsschaden□-3.2 angriffsgeschwindigkeit",
  "item.minecraft.stone_sword": "steinschwert□□in der haupthand:□+4 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.stone_shovel": "steinschaufel□□in der haupthand:□+2.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.stone_pickaxe": "steinspitzhacke□□in der haupthand:□+2 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.stone_axe": "steinaxt□□in der haupthand:□+8 angriffsschaden□-3.2 angriffsgeschwindigkeit",
  "item.minecraft.diamond_sword": "diamantschwert□□in der haupthand:□+6 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.diamond_shovel": "diamantschaufel□□in der haupthand:□+4.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.diamond_pickaxe": "diamantspitzhacke□□in der haupthand:□+4 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.diamond_axe": "diamantaxt□□in der haupthand:□+8 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.stick": "stock",
  "item.minecraft.bowl": "schüssel",
  "item.minecraft.mushroom_stew": "pilzsuppe",
  "item.minecraft.golden_sword": "goldschwert□□in der haupthand:□+3 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.golden_shovel": "goldschaufel□□in der haupthand:□+1.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.golden_pickaxe": "goldspitzhacke□□in der haupthand:□+1 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.golden_axe": "goldaxt□□in der haupthand:□+6 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.netherite_sword": "netheritschwert□□in der haupthand:□+7 angriffsschaden□-2.4 angriffsgeschwindigkeit",
  "item.minecraft.netherite_shovel": "netheritschaufel□□in der haupthand:□+5.5 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.netherite_pickaxe": "netheritspitzhacke□□in der haupthand:□+5 angriffsschaden□-2.8 angriffsgeschwindigkeit",
  "item.minecraft.netherite_axe": "netheritaxt□□in der haupthand:□+9 angriffsschaden□-3 angriffsgeschwindigkeit",
  "item.minecraft.string": "faden",
  "item.minecraft.feather": "feder",
  "item.minecraft.gunpowder": "schwarzpulver",
  "item.minecraft.wooden_hoe": "holzhacke□□in der haupthand:□-3 angriffsgeschwindigkeit",
  "item.minecraft.stone_hoe": "steinhacke□□in der haupthand:□-2 angriffsgeschwindigkeit",
  "item.minecraft.iron_hoe": "eisenhacke□□in der haupthand:□-1 angriffsgeschwindigkeit",
  "item.minecraft.diamond_hoe": "diamanthacke□□in der haupthand:",
  "item.minecraft.golden_hoe": "goldhacke□□in der haupthand:□-3 angriffsgeschwindigkeit",
  "item.minecraft.netherite_hoe": "netherithacke□□in der haupthand:",
  "item.minecraft.wheat_seeds": "weizenkörner",
  "item.minecraft.wheat": "weizen",
  "item.minecraft.bread": "brot",
  "item.minecraft.leather_helmet": "lederkappe□□auf dem kopf:□+1 rüstung",
  "item.minecraft.leather_chestplate": "lederjacke□□am körper:□+3 rüstung",
  "item.minecraft.leather_leggings": "lederhose□□an den beinen:□+2 rüstung",
  "item.minecraft.leather_boots": "lederstiefel□□an den füßen:□+1 rüstung",
  "item.minecraft.chainmail_helmet": "kettenhaube□□auf dem kopf:□+2 rüstung",
  "item.minecraft.chainmail_chestplate": "kettenhemd□□am körper:□+5 rüstung",
  "item.minecraft.chainmail_leggings": "kettenhose□□an den beinen:□+4 rüstung",
  "item.minecraft.chainmail_boots": "kettenstiefel□□an den füßen:□+1 rüstung",
  "item.minecraft.iron_helmet": "eisenhelm□□auf dem kopf:□+2 rüstung",
  "item.minecraft.iron_chestplate": "eisenharnisch□□am körper:□+6 rüstung",
  "item.minecraft.iron_leggings": "eisenbeinschutz□□an den beinen:□+5 rüstung",
  "item.minecraft.iron_boots": "eisenstiefel□□an den füßen:□+2 rüstung",
  "item.minecraft.diamond_helmet": "diamanthelm□□auf dem kopf:□+3 rüstung□+2 rüstungshärte",
  "item.minecraft.diamond_chestplate": "diamantharnisch□□am körper:□+8 rüstung□+2 rüstungshärte",
  "item.minecraft.diamond_leggings": "diamantbeinschutz□□an den beinen:□+6 rüstung□+2 rüstungshärte",
  "item.minecraft.diamond_boots": "diamantstiefel□□an den füßen:□+3 rüstung□+2 rüstungshärte",
  "item.minecraft.golden_helmet": "goldhelm□□auf dem kopf:□+2 rüstung",
  "item.minecraft.golden_chestplate": "goldharnisch□□am körper:□+5 rüstung",
  "item.minecraft.golden_leggings": "goldbeinschutz□□an den beinen:□+3 rüstung",
  "item.minecraft.golden_boots": "goldstiefel□□an den füßen:□+1 rüstung",
  "item.minecraft.netherite_helmet": "netherithelm□□auf dem kopf:□+3 rüstung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.netherite_chestplate": "netheritharnisch□□am körper:□+8 rüstung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.netherite_leggings": "netheritbeinschutz□□an den beinen:□+6 rüstung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.netherite_boots": "netheritstiefel□□an den füßen:□+3 rüstung□+3 rüstungshärte□+1 standfestigkeit",
  "item.minecraft.flint": "feuerstein",
  "item.minecraft.porkchop": "rohes schweinefleisch",
  "item.minecraft.cooked_porkchop": "gebratenes schweinefleisch",
  "item.minecraft.painting": "gemälde",
  "item.minecraft.golden_apple": "goldener apfel",
  "item.minecraft.enchanted_golden_apple": "verzauberter goldener apfel",
  "block.minecraft.oak_sign": "eichenholzschild",
  "block.minecraft.spruce_sign": "fichtenholzschild",
  "block.minecraft.birch_sign": "birkenholzschild",
  "block.minecraft.jungle_sign": "tropenholzschild",
  "block.minecraft.acacia_sign": "akazienholzschild",
  "block.minecraft.dark_oak_sign": "schwarzeichenholzschild",
  "block.minecraft.crimson_sign": "karmesinschild",
  "block.minecraft.warped_sign": "wirrschild",
  "item.minecraft.bucket": "eimer",
  "item.minecraft.water_bucket": "wassereimer",
  "item.minecraft.lava_bucket": "lavaeimer",
  "item.minecraft.minecart": "lore",
  "item.minecraft.saddle": "sattel",
  "item.minecraft.redstone": "redstone-staub",
  "item.minecraft.snowball": "schneeball",
  "item.minecraft.oak_boat": "eichenholzboot",
  "item.minecraft.leather": "leder",
  "item.minecraft.milk_bucket": "milcheimer",
  "item.minecraft.pufferfish_bucket": "kugelfischeimer",
  "item.minecraft.salmon_bucket": "lachseimer",
  "item.minecraft.cod_bucket": "kabeljaueimer",
  "item.minecraft.tropical_fish_bucket": "tropenfischeimer",
  "item.minecraft.brick": "ziegel",
  "item.minecraft.clay_ball": "tonklumpen",
  "block.minecraft.dried_kelp_block": "getrockneter seetangblock",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "buch",
  "item.minecraft.slime_ball": "schleimball",
  "item.minecraft.chest_minecart": "güterlore",
  "item.minecraft.furnace_minecart": "ofenlore",
  "item.minecraft.egg": "ei",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "angel",
  "item.minecraft.clock": "uhr",
  "item.minecraft.glowstone_dust": "glowstone-staub",
  "item.minecraft.cod": "roher kabeljau",
  "item.minecraft.salmon": "roher lachs",
  "item.minecraft.tropical_fish": "tropenfisch",
  "item.minecraft.pufferfish": "kugelfisch",
  "item.minecraft.cooked_cod": "gebratener kabeljau",
  "item.minecraft.cooked_salmon": "gebratener lachs",
  "item.minecraft.ink_sac": "tintenbeutel",
  "item.minecraft.red_dye": "roter farbstoff",
  "item.minecraft.green_dye": "grüner farbstoff",
  "item.minecraft.cocoa_beans": "kakaobohnen",
  "item.minecraft.lapis_lazuli": "lapislazuli",
  "item.minecraft.purple_dye": "violetter farbstoff",
  "item.minecraft.cyan_dye": "türkiser farbstoff",
  "item.minecraft.light_gray_dye": "hellgrauer farbstoff",
  "item.minecraft.gray_dye": "grauer farbstoff",
  "item.minecraft.pink_dye": "rosa farbstoff",
  "item.minecraft.lime_dye": "hellgrüner farbstoff",
  "item.minecraft.yellow_dye": "gelber farbstoff",
  "item.minecraft.light_blue_dye": "hellblauer farbstoff",
  "item.minecraft.magenta_dye": "magenta farbstoff",
  "item.minecraft.orange_dye": "oranger farbstoff",
  "item.minecraft.bone_meal": "knochenmehl",
  "item.minecraft.blue_dye": "blauer farbstoff",
  "item.minecraft.brown_dye": "brauner farbstoff",
  "item.minecraft.black_dye": "schwarzer farbstoff",
  "item.minecraft.white_dye": "weißer farbstoff",
  "item.minecraft.bone": "knochen",
  "item.minecraft.sugar": "zucker",
  "block.minecraft.cake": "kuchen",
  "block.minecraft.white_bed": "weißes bett",
  "block.minecraft.orange_bed": "oranges bett",
  "block.minecraft.magenta_bed": "magenta bett",
  "block.minecraft.light_blue_bed": "hellblaues bett",
  "block.minecraft.yellow_bed": "gelbes bett",
  "block.minecraft.lime_bed": "hellgrünes bett",
  "block.minecraft.pink_bed": "rosa bett",
  "block.minecraft.gray_bed": "graues bett",
  "block.minecraft.light_gray_bed": "hellgraues bett",
  "block.minecraft.cyan_bed": "türkises bett",
  "block.minecraft.purple_bed": "violettes bett",
  "block.minecraft.blue_bed": "blaues bett",
  "block.minecraft.brown_bed": "braunes bett",
  "block.minecraft.green_bed": "grünes bett",
  "block.minecraft.red_bed": "rotes bett",
  "block.minecraft.black_bed": "schwarzes bett",
  "item.minecraft.cookie": "keks",
  "item.minecraft.filled_map": "karte□#0",
  "item.minecraft.shears": "schere",
  "item.minecraft.melon_slice": "melonenscheibe",
  "item.minecraft.dried_kelp": "getrockneter seetang",
  "item.minecraft.pumpkin_seeds": "kürbiskerne",
  "item.minecraft.melon_seeds": "melonenkerne",
  "item.minecraft.beef": "rohes rindfleisch",
  "item.minecraft.cooked_beef": "steak",
  "item.minecraft.chicken": "rohes hühnchen",
  "item.minecraft.cooked_chicken": "gebratenes hühnchen",
  "item.minecraft.rotten_flesh": "verrottetes fleisch",
  "item.minecraft.ender_pearl": "enderperle",
  "item.minecraft.blaze_rod": "lohenrute",
  "item.minecraft.ghast_tear": "ghast-träne",
  "item.minecraft.gold_nugget": "goldklumpen",
  "item.minecraft.nether_wart": "netherwarze",
  "item.minecraft.potion": "nicht braubarer trank□wirkungslos",
  "item.minecraft.glass_bottle": "glasflasche",
  "item.minecraft.spider_eye": "spinnenauge",
  "item.minecraft.fermented_spider_eye": "fermentiertes spinnenauge",
  "item.minecraft.blaze_powder": "lohenstaub",
  "item.minecraft.magma_cream": "magmacreme",
  "block.minecraft.brewing_stand": "braustand",
  "block.minecraft.cauldron": "kessel",
  "item.minecraft.ender_eye": "enderauge",
  "item.minecraft.glistering_melon_slice": "glitzernde melonenscheibe",
  "item.minecraft.bat_spawn_egg": "fledermaus-spawn-ei",
  "item.minecraft.bee_spawn_egg": "bienen-spawn-ei",
  "item.minecraft.blaze_spawn_egg": "lohen-spawn-ei",
  "item.minecraft.cat_spawn_egg": "katzen-spawn-ei",
  "item.minecraft.cave_spider_spawn_egg": "höhlenspinnen-spawn-ei",
  "item.minecraft.chicken_spawn_egg": "huhn-spawn-ei",
  "item.minecraft.cod_spawn_egg": "kabeljau-spawn-ei",
  "item.minecraft.cow_spawn_egg": "kuh-spawn-ei",
  "item.minecraft.creeper_spawn_egg": "creeper-spawn-ei",
  "item.minecraft.dolphin_spawn_egg": "delfin-spawn-ei",
  "item.minecraft.donkey_spawn_egg": "esel-spawn-ei",
  "item.minecraft.drowned_spawn_egg": "ertrunkenen-spawn-ei",
  "item.minecraft.elder_guardian_spawn_egg": "großer-wächter-spawn-ei",
  "item.minecraft.enderman_spawn_egg": "enderman-spawn-ei",
  "item.minecraft.endermite_spawn_egg": "endermiten-spawn-ei",
  "item.minecraft.evoker_spawn_egg": "magier-spawn-ei",
  "item.minecraft.fox_spawn_egg": "fuchs-spawn-ei",
  "item.minecraft.ghast_spawn_egg": "ghast-spawn-ei",
  "item.minecraft.guardian_spawn_egg": "wächter-spawn-ei",
  "item.minecraft.hoglin_spawn_egg": "hoglin-spawn-ei",
  "item.minecraft.horse_spawn_egg": "pferde-spawn-ei",
  "item.minecraft.husk_spawn_egg": "wüstenzombie-spawn-ei",
  "item.minecraft.llama_spawn_egg": "lama-spawn-ei",
  "item.minecraft.magma_cube_spawn_egg": "magmawürfel-spawn-ei",
  "item.minecraft.mooshroom_spawn_egg": "mooshroom-spawn-ei",
  "item.minecraft.mule_spawn_egg": "maultier-spawn-ei",
  "item.minecraft.ocelot_spawn_egg": "ozelot-spawn-ei",
  "item.minecraft.panda_spawn_egg": "panda-spawn-ei",
  "item.minecraft.parrot_spawn_egg": "papageien-spawn-ei",
  "item.minecraft.phantom_spawn_egg": "phantom-spawn-ei",
  "item.minecraft.pig_spawn_egg": "schweine-spawn-ei",
  "item.minecraft.piglin_spawn_egg": "piglin-spawn-ei",
  "item.minecraft.pillager_spawn_egg": "plünderer-spawn-ei",
  "item.minecraft.polar_bear_spawn_egg": "eisbären-spawn-ei",
  "item.minecraft.pufferfish_spawn_egg": "kugelfisch-spawn-ei",
  "item.minecraft.rabbit_spawn_egg": "kaninchen-spawn-ei",
  "item.minecraft.ravager_spawn_egg": "verwüster-spawn-ei",
  "item.minecraft.salmon_spawn_egg": "lachs-spawn-ei",
  "item.minecraft.sheep_spawn_egg": "schafs-spawn-ei",
  "item.minecraft.shulker_spawn_egg": "shulker-spawn-ei",
  "item.minecraft.silverfish_spawn_egg": "silberfischchen-spawn-ei",
  "item.minecraft.skeleton_spawn_egg": "skelett-spawn-ei",
  "item.minecraft.skeleton_horse_spawn_egg": "skelettpferde-spawn-ei",
  "item.minecraft.slime_spawn_egg": "schleim-spawn-ei",
  "item.minecraft.spider_spawn_egg": "spinnen-spawn-ei",
  "item.minecraft.squid_spawn_egg": "tintenfisch-spawn-ei",
  "item.minecraft.stray_spawn_egg": "eiswanderer-spawn-ei",
  "item.minecraft.strider_spawn_egg": "schreiter-spawn-ei",
  "item.minecraft.trader_llama_spawn_egg": "händlerlama-spawn-ei",
  "item.minecraft.tropical_fish_spawn_egg": "tropenfisch-spawn-ei",
  "item.minecraft.turtle_spawn_egg": "schildkröten-spawn-ei",
  "item.minecraft.vex_spawn_egg": "plagegeister-spawn-ei",
  "item.minecraft.villager_spawn_egg": "dorfbewohner-spawn-ei",
  "item.minecraft.vindicator_spawn_egg": "diener-spawn-ei",
  "item.minecraft.wandering_trader_spawn_egg": "fahrender-händler-spawn-ei",
  "item.minecraft.witch_spawn_egg": "hexen-spawn-ei",
  "item.minecraft.wither_skeleton_spawn_egg": "witherskelett-spawn-ei",
  "item.minecraft.wolf_spawn_egg": "wolfs-spawn-ei",
  "item.minecraft.zoglin_spawn_egg": "zoglin-spawn-ei",
  "item.minecraft.zombie_spawn_egg": "zombie-spawn-ei",
  "item.minecraft.zombie_horse_spawn_egg": "zombiepferde-spawn-ei",
  "item.minecraft.zombie_villager_spawn_egg": "zombiedorfbewohner-spawn-ei",
  "item.minecraft.zombified_piglin_spawn_egg": "zombifizierter-piglin-spawn-ei",
  "item.minecraft.experience_bottle": "erfahrungsfläschchen",
  "item.minecraft.fire_charge": "feuerkugel",
  "item.minecraft.writable_book": "buch und feder",
  "item.minecraft.written_book": "beschriebenes buch",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "rahmen",
  "block.minecraft.flower_pot": "blumentopf",
  "item.minecraft.carrot": "karotte",
  "item.minecraft.potato": "kartoffel",
  "item.minecraft.baked_potato": "ofenkartoffel",
  "item.minecraft.poisonous_potato": "giftige kartoffel",
  "item.minecraft.map": "leere karte",
  "item.minecraft.golden_carrot": "goldene karotte",
  "block.minecraft.skeleton_skull": "skelettschädel",
  "block.minecraft.wither_skeleton_skull": "witherskelettschädel",
  "block.minecraft.player_head": "spielerkopf",
  "block.minecraft.zombie_head": "zombiekopf",
  "block.minecraft.creeper_head": "creeperkopf",
  "block.minecraft.dragon_head": "drachenkopf",
  "item.minecraft.carrot_on_a_stick": "karottenrute",
  "item.minecraft.warped_fungus_on_a_stick": "wirrpilzrute",
  "item.minecraft.nether_star": "netherstern",
  "item.minecraft.pumpkin_pie": "kürbiskuchen",
  "item.minecraft.firework_rocket": "feuerwerksrakete",
  "item.minecraft.firework_star": "feuerwerksstern",
  "item.minecraft.enchanted_book": "verzaubertes buch",
  "item.minecraft.nether_brick": "netherziegel",
  "item.minecraft.quartz": "netherquarz",
  "item.minecraft.tnt_minecart": "tnt-lore",
  "item.minecraft.hopper_minecart": "trichterlore",
  "item.minecraft.prismarine_shard": "prismarinscherbe",
  "item.minecraft.prismarine_crystals": "prismarinkristalle",
  "item.minecraft.rabbit": "rohes kaninchen",
  "item.minecraft.cooked_rabbit": "gebratenes kaninchen",
  "item.minecraft.rabbit_stew": "kaninchenragout",
  "item.minecraft.rabbit_foot": "hasenpfote",
  "item.minecraft.rabbit_hide": "kaninchenfell",
  "item.minecraft.armor_stand": "rüstungsständer",
  "item.minecraft.iron_horse_armor": "eiserner rossharnisch",
  "item.minecraft.golden_horse_armor": "goldener rossharnisch",
  "item.minecraft.diamond_horse_armor": "diamantener rossharnisch",
  "item.minecraft.leather_horse_armor": "lederner rossharnisch",
  "item.minecraft.lead": "leine",
  "item.minecraft.name_tag": "namensschild",
  "item.minecraft.command_block_minecart": "befehlsblocklore",
  "item.minecraft.mutton": "rohes hammelfleisch",
  "item.minecraft.cooked_mutton": "gebratenes hammelfleisch",
  "block.minecraft.white_banner": "weißes banner",
  "block.minecraft.orange_banner": "oranges banner",
  "block.minecraft.magenta_banner": "magenta banner",
  "block.minecraft.light_blue_banner": "hellblaues banner",
  "block.minecraft.yellow_banner": "gelbes banner",
  "block.minecraft.lime_banner": "hellgrünes banner",
  "block.minecraft.pink_banner": "rosa banner",
  "block.minecraft.gray_banner": "graues banner",
  "block.minecraft.light_gray_banner": "hellgraues banner",
  "block.minecraft.cyan_banner": "türkises banner",
  "block.minecraft.purple_banner": "violettes banner",
  "block.minecraft.blue_banner": "blaues banner",
  "block.minecraft.brown_banner": "braunes banner",
  "block.minecraft.green_banner": "grünes banner",
  "block.minecraft.red_banner": "rotes banner",
  "block.minecraft.black_banner": "schwarzes banner",
  "item.minecraft.end_crystal": "enderkristall",
  "item.minecraft.chorus_fruit": "chorusfrucht",
  "item.minecraft.popped_chorus_fruit": "geplatzte chorusfrucht",
  "item.minecraft.beetroot": "rote bete",
  "item.minecraft.beetroot_seeds": "rote-bete-samen",
  "item.minecraft.beetroot_soup": "borschtsch",
  "item.minecraft.dragon_breath": "drachenatem",
  "item.minecraft.splash_potion": "nicht braubarer wurftrank□wirkungslos",
  "item.minecraft.spectral_arrow": "spektralpfeil",
  "item.minecraft.tipped_arrow": "nicht herstellbarer getränkter pfeil□wirkungslos",
  "item.minecraft.lingering_potion": "nicht braubarer verweiltrank□wirkungslos",
  "item.minecraft.shield": "schild",
  "item.minecraft.elytra": "elytren",
  "item.minecraft.spruce_boat": "fichtenholzboot",
  "item.minecraft.birch_boat": "birkenholzboot",
  "item.minecraft.jungle_boat": "tropenholzboot",
  "item.minecraft.acacia_boat": "akazienholzboot",
  "item.minecraft.dark_oak_boat": "schwarzeichenholzboot",
  "item.minecraft.totem_of_undying": "totem der unsterblichkeit",
  "item.minecraft.shulker_shell": "shulker-schale",
  "item.minecraft.iron_nugget": "eisenklumpen",
  "item.minecraft.knowledge_book": "buch des wissens",
  "item.minecraft.debug_stick": "debug-stab",
  "item.minecraft.music_disc_13": "schallplatte□c418 - 13",
  "item.minecraft.music_disc_cat": "schallplatte□c418 - cat",
  "item.minecraft.music_disc_blocks": "schallplatte□c418 - blocks",
  "item.minecraft.music_disc_chirp": "schallplatte□c418 - chirp",
  "item.minecraft.music_disc_far": "schallplatte□c418 - far",
  "item.minecraft.music_disc_mall": "schallplatte□c418 - mall",
  "item.minecraft.music_disc_mellohi": "schallplatte□c418 - mellohi",
  "item.minecraft.music_disc_stal": "schallplatte□c418 - stal",
  "item.minecraft.music_disc_strad": "schallplatte□c418 - strad",
  "item.minecraft.music_disc_ward": "schallplatte□c418 - ward",
  "item.minecraft.music_disc_11": "schallplatte□c418 - 11",
  "item.minecraft.music_disc_wait": "schallplatte□c418 - wait",
  "item.minecraft.music_disc_pigstep": "schallplatte□lena raine - pigstep",
  "item.minecraft.trident": "dreizack□□in der haupthand:□+8 angriffsschaden□-2.9 angriffsgeschwindigkeit",
  "item.minecraft.phantom_membrane": "phantomhaut",
  "item.minecraft.nautilus_shell": "nautilusschale",
  "item.minecraft.heart_of_the_sea": "herz des meeres",
  "item.minecraft.crossbow": "armbrust",
  "item.minecraft.suspicious_stew": "seltsame suppe",
  "block.minecraft.loom": "webstuhl",
  "item.minecraft.flower_banner_pattern": "bannervorlage□blume",
  "item.minecraft.creeper_banner_pattern": "bannervorlage□creeper",
  "item.minecraft.skull_banner_pattern": "bannervorlage□schädel",
  "item.minecraft.mojang_banner_pattern": "bannervorlage□mojang-logo",
  "item.minecraft.globe_banner_pattern": "bannervorlage□globus",
  "item.minecraft.piglin_banner_pattern": "bannervorlage□schnauze",
  "block.minecraft.composter": "komposter",
  "block.minecraft.barrel": "fass",
  "block.minecraft.smoker": "räucherofen",
  "block.minecraft.blast_furnace": "schmelzofen",
  "block.minecraft.cartography_table": "kartentisch",
  "block.minecraft.fletching_table": "bognertisch",
  "block.minecraft.grindstone": "schleifstein",
  "block.minecraft.lectern": "lesepult",
  "block.minecraft.smithing_table": "schmiedetisch",
  "block.minecraft.stonecutter": "steinsäge",
  "block.minecraft.bell": "glocke",
  "block.minecraft.lantern": "laterne",
  "block.minecraft.soul_lantern": "seelenlaterne",
  "item.minecraft.sweet_berries": "süßbeeren",
  "block.minecraft.campfire": "lagerfeuer",
  "block.minecraft.soul_campfire": "seelenlagerfeuer",
  "block.minecraft.shroomlight": "pilzlicht",
  "item.minecraft.honeycomb": "honigwabe",
  "block.minecraft.bee_nest": "bienennest",
  "block.minecraft.beehive": "bienenstock",
  "item.minecraft.honey_bottle": "honigflasche",
  "block.minecraft.honey_block": "honigblock",
  "block.minecraft.honeycomb_block": "honigwabenblock",
  "block.minecraft.lodestone": "leitstein",
  "block.minecraft.netherite_block": "netheritblock",
  "block.minecraft.ancient_debris": "antiker schrott",
  "block.minecraft.target": "zielblock",
  "block.minecraft.crying_obsidian": "weinender obsidian",
  "block.minecraft.blackstone": "schwarzstein",
  "block.minecraft.blackstone_slab": "schwarzsteinstufe",
  "block.minecraft.blackstone_stairs": "schwarzsteintreppe",
  "block.minecraft.gilded_blackstone": "golddurchzogener schwarzstein",
  "block.minecraft.polished_blackstone": "polierter schwarzstein",
  "block.minecraft.polished_blackstone_slab": "polierte schwarzsteinstufe",
  "block.minecraft.polished_blackstone_stairs": "polierte schwarzsteintreppe",
  "block.minecraft.chiseled_polished_blackstone": "gemeißelter polierter schwarzstein",
  "block.minecraft.polished_blackstone_bricks": "polierte schwarzsteinziegel",
  "block.minecraft.polished_blackstone_brick_slab": "polierte schwarzsteinziegelstufe",
  "block.minecraft.polished_blackstone_brick_stairs": "polierte schwarzsteinziegeltreppe",
  "block.minecraft.cracked_polished_blackstone_bricks": "rissige polierte schwarzsteinziegel",
  "block.minecraft.respawn_anchor": "seelenanker",
}
export const de_de = items; 
